import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';


  
  export const crmManagementsSlice = createSlice({
    name: 'crmManagements',
    initialState,
    reducers: {
      setCrmManagements:(state, action) => {
        state.crmManagementsData = action.payload
      }
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const { setCrmManagements } = crmManagementsSlice.actions
  
  export default crmManagementsSlice.reducer